// extracted by mini-css-extract-plugin
module.exports = {"transfer_resume_image":"Resume_transfer_resume_image__EKQcy","transfer_amount":"Resume_transfer_amount__3sivi","transfer_value":"Resume_transfer_value__fFNIA"};